import React, { useEffect, useState } from 'react'
import { green_rec, left_arrow, no_image, white_rec } from '../../assets/imgs'
import { useLocation, useNavigate } from 'react-router-dom'
import { useLazyOwnersDropListQuery, useLazyReceptionListViewQuery, useReceptionListAddMutation, useReceptionListEditMutation } from '../redux/api/api';
import { toast } from 'react-toastify';

const ReceptionAdd = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [name, setName] = useState();
    const [email, setEmail] = useState();
    const [mobile, setMobile] = useState();
    const [secMobile, setSecMobile] = useState();
    const [gender, setGender] = useState();
    const [address, setAddress] = useState();
    const [ownerName, setOwnerName] = useState();
    const [loader, setLoader] = useState(false);
    const [ownersList, setOwnersList] = useState([]);
    const [profileImage, setProfileImage] = useState();

    const id = location?.state?.id;
    const type = location?.state?.type;

    const [receptionViewApi] = useLazyReceptionListViewQuery();
    const [receptionEditApi] = useReceptionListEditMutation();
    const [receptionAddApi] = useReceptionListAddMutation();
    const [OwnersDropApi] = useLazyOwnersDropListQuery();

    const receptionListView = (id) => {
        receptionViewApi(id)
            .unwrap()
            .then((res) => {
                console.log("res", res);
                setName(res?.data?.name);
                setEmail(res?.data?.email);
                setMobile(res?.data?.mobile);
                setAddress(res?.data?.address);
                setGender(res?.data?.gender);
                setSecMobile(res?.data?.secondary_number);
                setOwnerName(res?.data?.owner?.id);
                setProfileImage(res?.data?.image_url ? res?.data?.image_url : no_image);
            })
            .catch((err) => {
                console.log("err", err);
            })
    }

    console.log("owner", ownerName);

    const ownersListDrop = () => {
        OwnersDropApi()
            .unwrap()
            .then((res) => {
                console.log("res", res);
                setOwnersList(res?.owners)
            })
            .catch((err) => {
                console.log("err", err);
            })
    }

    useEffect(() => {
        if (id) {
            receptionListView(id);
        }
        ownersListDrop();
    }, []);

    const receptionEdit = (id) => {
        const regEx = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!name) {
            toast.error("Enter Name");
            return;
        }
        if (!email || !regEx.test(email)) {
            toast.error("Enter Valid Email");
            return;
        } if (!mobile) {
            toast.error("Enter Number");
            return;
        }if (mobile?.length !== 10 ) {
            toast.error("Enter Number");
            return;
        }  if (!address) {
            toast.error("Enter Address");
            return;
        }
        const formdata = new FormData();
        formdata.append("name", name);
        formdata.append("email", email);
        formdata.append("mobile", mobile);
        formdata.append("address", address);
        formdata.append("gender", gender);
        if (secMobile) {
            formdata.append("secondary_number", secMobile);
        }
        formdata.append("owner_id", ownerName);
        receptionEditApi({ payload: formdata, id: id })
            .unwrap()
            .then((res) => {
                console.log("res", res);
                setLoader(true);
                if (res?.status == "success") {
                    setLoader(true)
                    toast.success(res?.message);
                    navigate(-1);
                    setName("");
                    setEmail("");
                    setMobile("");
                    setAddress("");
                    setGender("");
                    setSecMobile("");
                }

            })
            .catch((err) => {
                setLoader(false);
                console.log("err", err);
            }).finally(() => {
                setLoader(false);
            })
    }

    const receptionAdd = () => {
        const regEx = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!name) {
            toast.error("Enter Name");
            return;
        }
        if (!email || !regEx.test(email)) {
            toast.error("Enter Valid Email");
            return;
        } if (!mobile) {
            toast.error("Enter Number");
            return;
        }if (mobile?.length !== 10 ) {
            toast.error("Enter Number");
            return;
        } if (!ownerName) {
            toast.error("Select Owner Name");
            return;
        } if (!address) {
            toast.error("Enter Address");
            return;
        }

        const formdata = new FormData();
        formdata.append("name", name);
        formdata.append("email", email);
        formdata.append("mobile", mobile);
        formdata.append("address", address);
        formdata.append("gender", gender);
        formdata.append("owner_id", ownerName);
        formdata.append("secondary_number", secMobile);
        receptionAddApi(formdata)
            .unwrap()
            .then((res) => {
                console.log("res", res);
                setLoader(true);
                if (res?.status == "success") {
                    setLoader(true)
                    toast.success(res?.message);
                    navigate(-1);
                    setName("");
                    setEmail("");
                    setMobile("");
                    setAddress("");
                    setGender("");
                    setSecMobile("");
                }

            })
            .catch((err) => {
                setLoader(false);
                console.log("err", err);
            })
    }



    return (
        <div className="dashRightView home_section">
            <div className='d-flex ac-jb'>
                <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 sec ">
                    Receptionist {type == "edit" ? "Edit" : "Add"}
                </h2>
                <div className='d-flex gap-2'>
                    <img src={profileImage} onChange={(e) => setProfileImage(e.target.value)} className="profile-img " />
                </div>
            </div>
            <div className='d-flex ac-js gap-2'
                onClick={() => navigate(-1)}
            >
                <img src={left_arrow} className='leftArrow mb-3' />
                <p className="f2 fs-sm-10 fs-md-16 fs-lg-16 fs-xl-18 fs-xxl-20 primary">Back</p>
            </div>
            <div className="">
                <div className='d-flex gap-5'>
                    <div className='col-md-5'>
                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Name *
                        </h4>
                        <input type="text" value={name} onChange={(e) => setName(e.target.value)} className="input-pop ps-2 w-100" placeholder="Name" />
                    </div>
                    <div className='col-md-5'>
                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Email *
                        </h4>
                        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="input-pop ps-2 w-100" placeholder="Owner Name" />
                    </div>
                </div>
                <div className='d-flex gap-5'>
                    <div className='col-md-5'>
                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Mobile Number *
                        </h4>
                        <input type="number" readOnly={type == "edit" ? true : false} value={mobile} onChange={(e) => setMobile(e.target.value)} onInput={(e) => e.target.value = e.target.value.slice(0, 10)} className="input-pop ps-2 w-100" placeholder="Mobile Number" />
                    </div>
                    <div className='col-md-5'>
                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Secondary Mobile Number
                        </h4>
                        <input type="number" value={secMobile} onChange={(e) => setSecMobile(e.target.value)} onInput={(e) => e.target.value = e.target.value.slice(0, 10)} className="input-pop ps-2 w-100" placeholder="Secondary Mobile Number" />
                    </div>
                </div>

                <div className='d-flex gap-5 mb-4'>
                    <div className='col-md-5'>
                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Gender 
                        </h4>
                        <select disabled={type == "view" ? true : false} value={gender} onChange={(e) => setGender(e.target.value)} className='input-pop ps-2 w-100'>
                            <option value={''}>Select Gender</option>
                            <option value={1}>Male</option>
                            <option value={2}>Female</option>
                        </select>
                    </div>
                    <div className='col-md-5'>
                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Owner Name *
                        </h4>
                        <select
                            value={ownerName}
                            onChange={(e) => setOwnerName(e.target.value)}
                            className='input-pop ps-2 w-100'
                        >
                            <option value={''}>Select Owner</option>
                            {ownersList.map((item) => (
                                <option value={item?.id} key={item?.id}>{item?.name}</option>
                            ))}
                        </select>
                    </div>

                </div>
                <div className='d-flex gap-5 mb-4'>
                    <div className='col-md-5'>
                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Address *
                        </h4>
                        <textarea type="text" value={address} onChange={(e) => setAddress(e.target.value)} className="input-pop ps-2 w-100 h-100" placeholder="Address" />
                    </div>
                </div>
            </div>
            <div className="col-md-11 d-flex ac-je pe-4 mt-5">
                <button onClick={() => { type == "edit" ? receptionEdit(id) : receptionAdd() }} className="login-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "  >
                    {loader && (
                        <div
                            class="spinner-border spinner-border-sm "
                            role="status"
                            style={{ marginRight: "5px" }}
                        ></div>
                    )}
                    Submit
                </button>
            </div>
        </div>
    )
}

export default ReceptionAdd